var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",class:_vm.containerClass},[_c('d-title',{attrs:{"title":"views.dashboard.content.activities.title","container-class":"ml-3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }